import { CSNumberTuple, QuestionResultsFilterLabels } from "types";

import { PointMarkerOptionsObject } from "highcharts";
import { TimeViewDateFilter } from "consts";

export const timeviewViewTypes = ["percent", "count"] as const;
export type TimeviewViewType = (typeof timeviewViewTypes)[number];
export const timeviewBucketModes = ["daily", "weekly", "monthly", "quarterly", "yearly"] as const;
export type TimeviewBucketMode = (typeof timeviewBucketModes)[number];
export type TimeviewBucketModeWithNone = TimeviewBucketMode | "";

export type TimeviewBucketDisplay = `${TimeviewViewType}-${TimeviewBucketMode}`;

export const scoreTimeviewFilters = [
  TimeViewDateFilter.CountDaily,
  TimeViewDateFilter.CountWeekly,
  TimeViewDateFilter.CountMonthly,
  TimeViewDateFilter.CountQuarterly,
  TimeViewDateFilter.CountYearly,
] as const;

export type ScoreTimeviewDateFilterTypes = (typeof scoreTimeviewFilters)[number];

export type CSTimeViewChartResultData = {
  uri: string;
  label: string;
  order: number;
  count: number;
  pct: number;
};
export type CSTimeViewSeriesData = {
  visible?: boolean;
  data: CSNumberTuple[];
  name?: string;
  marker?: PointMarkerOptionsObject;
  lineWidth?: number;
};
export type TimeviewResultsBucketItem = {
  good?: boolean;
  seriesDates: Date[]; // "2020-07-15"
  count: CSNumberTuple[] | null;
  percent?: CSNumberTuple[] | null;
};
export type TimeViewChartDataType = Record<TimeviewBucketMode, TimeviewResultsBucketItem>;
export type TimeviewResultsData = {
  questionId: number;
  label: string;
  results: CSTimeViewChartResultData[];
  chartData: TimeViewChartDataType;
  totalCount: number;
  errorMargin: number;
  startTime: Date | string;
  endTime: Date | string;
  filters: QuestionResultsFilterLabels;
};
// *******************
// Score Timeviews
// *******************
export type ScoreTimeViewChartDateTypeObject = {
  count?: number[];
  percent?: number[];
  seriesDates?: Date[];
};
export type ScoreTimeViewChartDataType = Record<TimeviewBucketMode, ScoreTimeViewChartDateTypeObject>;
export type MultiTimeViewChartDateTypeObject = {
  count?: number[] | number[][];
  percent?: number[];
  seriesDates?: Date[];
};
export type MultiTimeViewChartDataType = Record<TimeviewBucketMode, MultiTimeViewChartDateTypeObject>;

// *******************
// Question Timeviews
// *******************
export type CSQuestionTimeViewCustomData = {
  totalCount: number;
};
export type CSQuestionTimeviewData = {
  x: number;
  y: number;
  custom: CSQuestionTimeViewCustomData;
};
export type CSQuestionTimeViewSeriesData = {
  visible?: boolean;
  turboThreshold: number;
  data: CSQuestionTimeviewData[];
  name?: string;
  marker?: PointMarkerOptionsObject;
  lineWidth?: number;
};
